import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import CircularProgress from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/CircularProgress';
import Typography from 'Components/UI/Typography';

const styles = theme => ({
  root: {
    position: 'fixed',
    height: '100vh',
    width: '100vw',
    backgroundColor: theme.palette.common.white,
    top: 0,
    left: 0,
    zIndex: theme.zIndex.modal,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
});

const SyncingProgress = ({
  className,
  classes,
  message,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <CircularProgress style={{ margin: 32 }} color="primary" size={50} />
      <Typography variant={'h5'}>{message}</Typography>
    </Box>
  );
};

SyncingProgress.defaultProps = {
  className: '',
  message: '',
};

SyncingProgress.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  message: PropTypes.string,
};

export default withStyles(styles)(SyncingProgress);
